module.exports = __webpack_public_path__ + "img/tie.2cb0621a.svg";